/** Нормализатор значения number-инпута для setValueAs:
 *  пустое/нечисловое (буквы и т.п.) — пустая строка, иначе число.
 *  RHF вызывает setValueAs и со строками (ввод), и с числами (дефолты/ref-реаттач),
 *  поэтому принимаем unknown. Использовать вместо valueAsNumber-опции RHF (ZEN #9). */
export function numberInputValue(value: unknown): number | '' {
  if (typeof value === 'number') {
    return Number.isNaN(value) ? '' : value;
  }

  const trimmed = String(value ?? '').trim();

  if (trimmed === '') return '';

  const parsed = Number(trimmed);
  return Number.isNaN(parsed) ? '' : parsed;
}
